export const environment = {
  production: false,
  apiUrl: 'https://develop.api.conectaoficina.com.br',

  // CMS
  jwtSecretKeyCms: 'L3kwcEZXqv+NSVu2lrjGRhdWnUxz59FJWmbpyX1DNVEFd+8CbCnqwP1aFqTdcvXu7tEqMG9JdS23',

  // flags
  skipAuth: false,
};
